import { createSelector } from "@reduxjs/toolkit";
//#region src/redux/modal-view/selectors.ts
var selectModalViewState = () => (store) => store.modalView;
var selectAllModalViews = () => createSelector([selectModalViewState()], (modalViewState) => modalViewState.modalViews);
var selecModalView = (id) => createSelector([selectAllModalViews()], (modalViews) => modalViews?.find((modalView) => modalView.id === id));
//#endregion
export { selecModalView, selectAllModalViews, selectModalViewState };

//# sourceMappingURL=selectors.js.map